@let option = optionData();

<odx-content-box
  class="content-box flex-column"
  [class.selected]="isSelected()"
  odxLayout="flex gap-none"
  (click)="onCardClicked()"
>
  <odx-area-header class="header">
    <h6 class="odx-heading-5 card-title">
      {{ option.displayName }}
    </h6>
    @if (isGroup()) {
      <odx-action-group class="group-menu">
        <button
          odxButton
          class="group-menu-button"
          [odxMenu]="groupMenu"
          odxMenuPosition="bottom-end"
          (click)="$event.stopPropagation()"
        >
          <odx-icon name="more" size="large" aria-hidden="true"></odx-icon>
        </button>
      </odx-action-group>
    }
  </odx-area-header>

  <div class="h-100 content">
    <div class="image-wrapper">
      <app-standard-image [imageUrl]="option.imageId"></app-standard-image>
    </div>

    @if (option.description || (option.matNr && option.option.devices.length === 1)) {
      <div class="content-details">
        @if (option.description) {
          <div class="feature">
            <p class="p-label odx-text--small" i18n="@@monitoringConfiguration.description">Beschreibung</p>
            <p class="odx-text--small">{{ option.description }}</p>
          </div>
        }

        @if (option.matNr && option.option.devices.length === 1) {
          <div class="feature">
            <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
            <p class="odx-text--small">{{ option.matNr }}</p>
          </div>
        }
      </div>
    }

    @if (option.configurationURL) {
      <div class="link-row" odxLayout="flex">
        <a
          odxLink
          class="card-link"
          [href]="option.configurationURL"
          target="_blank"
          rel="noopener noreferrer"
          (click)="$event.stopPropagation()"
        >
          <odx-icon name="document" inline></odx-icon>
          <span i18n="@@global.productDatasheet">Produktdatenblatt</span>
        </a>
      </div>
    }

    @if (option.piSheetURL) {
      <div class="link-row" odxLayout="flex">
        <a
          odxLink
          class="card-link"
          [href]="option.piSheetURL"
          target="_blank"
          rel="noopener noreferrer"
          (click)="$event.stopPropagation()"
        >
          <odx-icon name="document" inline></odx-icon>
          <span i18n="@@monitoringConfiguration.optionCard.piSheetURL">Produktinformationsblatt</span>
        </a>
      </div>
    }

    @if (!isBinary()) {
      <form odxForm class="quantity-form" (click)="$event.stopPropagation(); $event.preventDefault()">
        <odx-form-field i18n-label="@@global.quantity" label="Anzahl">
          <div odxLayout="flex" class="custom-spinbox" (click)="$event.stopPropagation()">
            <button
              type="button"
              data-icon-set="core"
              data-icon-name="minus"
              class="odx-spinbox__action odx-icon"
              aria-label="Decrease quantity"
              i18n-aria-label="@@monitoringConfiguration.optionCard.decreaseQuantity"
              (click)="$event.stopPropagation()"
              (click)="decrement()"
            ></button>
            <input
              class="odx-spinbox__input"
              odxFormFieldControl
              type="number"
              name="quantity"
              [ngModel]="quantity()"
              (click)="$event.stopPropagation()"
              (ngModelChange)="onQuantityChanged($event)"
              [attr.min]="minValue()"
              [attr.max]="maxValue()"
            />
            <button
              type="button"
              data-icon-set="core"
              data-icon-name="plus"
              class="odx-spinbox__action odx-icon"
              aria-label="Increase quantity"
              i18n-aria-label="@@monitoringConfiguration.optionCard.increaseQuantity"
              (click)="$event.stopPropagation()"
              (click)="increment()"
            ></button>
          </div>
        </odx-form-field>
      </form>
    }
  </div>

  <odx-content-box-footer class="footer w-100">
    <div odxLayout="flex" class="space-between">
      @if (selectionMode() === StepSelectionType.PICK1 || selectionMode() === StepSelectionType.PICK0TO1) {
        <odx-radio-button (click)="$event.stopPropagation()" [value]="option" i18n="@@global.select">Auswählen </odx-radio-button>
      }
      @if (selectionMode() === StepSelectionType.PICK0TON || selectionMode() === StepSelectionType.PICK1TON) {
        <odx-checkbox
          (click)="$event.stopPropagation()"
          [checked]="isSelected()"
          [class.has-error]="showError"
          (checkedChange)="onCheckedChanged($event)"
          #checkbox
          i18n="@@global.select"
        >
          Auswählen
        </odx-checkbox>
      }
    </div>
  </odx-content-box-footer>
</odx-content-box>

<ng-template #groupMenu>
  <odx-menu>
    <button odxButton odxMenuItem (click)="$event.stopPropagation(); showGroupDetails()">
      <odx-icon name="document" alignLeft></odx-icon>
      <span i18n="@@monitoring.groupedParts.menu.showComponents">Komponenten anzeigen</span>
    </button>
  </odx-menu>
</ng-template>
